import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";

import CashWithdrawalSessionCard from "../../components/CashWithdrawal/CashWithdrawalSessionCard";
import CashWithdrawalHistory from "../../components/CashWithdrawal/CashWithdrawalHistory";
import CashWithdrawalModal from "../../components/CashWithdrawal/CashWithdrawalModal";

const CashWithdrawalPage: React.FC = () => {

  return (

    <DefaultLayout>

      <BreadcrumbTwo />

      <div className="space-y-6">

        {/* Sesión actual */}
        <CashWithdrawalSessionCard />

        {/* Tabla de retiros */}
        <CashWithdrawalHistory />

      </div>

      {/* Modal retiro */}
      <CashWithdrawalModal />

    </DefaultLayout>

  );
};

export default CashWithdrawalPage;